import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { JobStateSummary } from "@/components/History/Content/Collection/JobStateSummary.js";
import CollectionDescription from "@/components/History/Content/Collection/CollectionDescription.vue";
import DetailsLayout from "@/components/History/Layout/DetailsLayout.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionDetails',
    props: {
        dsc: null,
        writeable: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const jobState = computed(() => {
            return new JobStateSummary(props.dsc);
        });
        return { __sfc: true, props, jobState, CollectionDescription, DetailsLayout };
    }
});
